/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import "../../styles/containers/LastCheckups.scss";
import PaperCard from "../../components/PaperCard";
import { backgroundColor, ratingColor } from "../../Constants";
import Loader from "../../components/Loader";
import { ToastContainer, toast } from "react-toastify";
import Message from "../../components/Message";
import { getAllCheckupsAPI } from "../../lib";
import { Auth, API } from "aws-amplify";
import { connect } from "react-redux";
import { useHistory } from "react-router";

function LastCheckups({ parkID, loginParkID, error }) {
  const [allLastcheckups, setAllLastCheckups] = useState([]);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(10);
  const [loading, setLoading] = useState(true);
  const loader = useRef(null);
  const [infoMessage, setInfoMessage] = useState("");
  const [loadMore, setLoadMore] = useState(true);
  let history = useHistory();

  useEffect(() => {
    var options = {
      root: null,
      rootMargin: "20px",
      threshold: 1.0,
    };
    // initialize IntersectionObserver
    // and attaching to Load More div
    if (parkID) {
      const observer = new IntersectionObserver(handleObserver, options);
      if (loader.current) {
        observer.observe(loader.current);
      }
    }
  }, [parkID]);

  async function getCheckups(offset, limit) {
    await API.get("UserQueries", "/api/v1/getallcheckups", {
      queryStringParameters: {
        offset,
        limit,
        park_id: parseInt(parkID) ? parseInt(parkID) : loginParkID,
      },
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        let newCheckups = res.message.rows ? res.message.rows : [];
        let checkupMessage = res.message.rows ? "" : res.message;
        if (newCheckups.length)
          setAllLastCheckups((previousData) => [
            ...previousData,
            ...newCheckups,
          ]);
        else setLoadMore(false);
        setInfoMessage(checkupMessage);
        setLoading(false);
      })
      .catch((err) => {
        let checkupError = err?.response?.data?.message
          ? err?.response?.data?.message
          : err.message;
        toast.error(`Error in getting last checkups ${checkupError}`);
        setLoading(false);
      });
  }

  useEffect(() => {
    if (parkID && loadMore) getCheckups(offset, limit);
  }, [offset, parkID]);

  useEffect(() => {
    if (error) setLoading(false);
  }, [error]);

  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      setOffset((offset) => offset + 10);
    }
  };

  const onClickHeading = (date) => {
    history.push(`/view-checkups/${date}`);
  };

  return (
    <div
      className="LastCheckups"
      style={loading || infoMessage ? { height: "100vh" } : { height: "100%" }}
    >
      <h1 className="main-heading">Last Checkups</h1>
      {loading ? (
        <Loader />
      ) : infoMessage ? (
        <Message message={infoMessage} />
      ) : (
        allLastcheckups.map((checkup, i) => {
          const date_created = checkup.date_created;
          return (
            <PaperCard
              key={i}
              heading={date_created.split("T")[0]}
              description={checkup.created_by}
              backgroundColor={backgroundColor.black}
              showHours={true}
              lastCheckups={true}
              hours={
                checkup.hours.hours
                  ? `${checkup.hours.hours}h`
                  : "Not available"
              }
              ratingReadonly={true}
              onClickHeading={() => onClickHeading(date_created.split("T")[0])}
              main
              taskLoader
              ratingValue={checkup.rating}
              ratingColor={
                checkup.rating >= 1 && checkup.rating < 3
                  ? ratingColor.red
                  : checkup.rating >= 3 && checkup.rating < 4
                  ? ratingColor.yellow
                  : ratingColor.green
              }
            />
          );
        })
      )}
      <div className="loading" ref={loader} />
      <ToastContainer position={toast.POSITION.TOP_RIGHT} autoClose={2000} />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    parkID: state?.users?.getUser?.user?.park_id,
    error: state?.users?.getUser?.error,
    loginParkID: state?.auth?.parkID,
  };
}

export default connect(mapStateToProps, null)(LastCheckups);
